import { PublishTermsErrorContainer } from '../PublishTermsError';
import * as React from 'react';

import { PublicationLayout } from '../PublicationLayout/PublicationLayout';

export const PublicationError = () => {
  return <PublicationLayout content={<PublishTermsErrorContainer />} />;
};
